export default __webpack_public_path__ + "62a4a64e5f1cf38172163b13e5edee33.png";